import DataSource from "devextreme/data/data_source";
import {useUserStore} from "@/store/models/user-store";
import {ref} from "vue";
/*import {Workbook} from 'exceljs';
import {saveAs} from 'file-saver-es';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {useFormaterStore} from "@/store/utility/formatter-store";
import {DateTime} from 'luxon';
import auth from "@/auth";
import notify from 'devextreme/ui/notify';*/
import {defineStore} from "pinia";
//import auth from "@/auth";

export const useUserManagementStore = defineStore(
    'userManagement',
    () => {

        //const enableChangePassword = ref(false);

        const branchesDataSource = ref([]);
        const rolesDataSource = ref([]);

        // Function to return the password for comparison
        const getPasswordComparison = () => {
            return useUserStore().selectedPassword;
        }

        const onEditingStart = (e) => {
            useUserStore().setSelectedRowBranchId(e.data.branch_id);
            useUserStore().setSelectedRowRoleId(e.data.role_id);
            useUserStore().setSelectedPassword("");
        }

        const onInitNewRow = () => {
            useUserStore().setSelectedRowBranchId(null);
            useUserStore().setSelectedRowRoleId(null);
            useUserStore().setSelectedPassword("");
        }

        const onSelectionBranch = (e) => {
            useUserStore().setSelectedRowBranchId(e.branch_id);
        }

        const onSelectionRole = (e) => {
            useUserStore().setSelectedRowRoleId(e.role_id);
        }

        const userDataSource = ref(
            new DataSource({
                requireTotalCount: true,
                store: useUserStore().listUserCustomStore,
                /*onLoadingChanged: (isLoading) => {
                    isLoading.value = isLoading;
                }*/
            })
        );


        /* const branchesDataSource = ref(
             new DataSource({
                 requireTotalCount: true,
                 store: useUserStore().listBranchesCustomStore,
             })
         );

         const rolesDataSource = ref(
             new DataSource({
                 requireTotalCount: true,
                 store: useUserStore().listRolesCustomStore,
             })
         );*/

        const initialize =()=>{
            useUserStore().fetchBranches().then(response => {
                branchesDataSource.value = response.data;
            });

            useUserStore().fetchRoles().then(response => {
                rolesDataSource.value = response.data;
            });
        };

        return {
            userDataSource,
            branchesDataSource,
            rolesDataSource,
            onEditingStart,
            onInitNewRow,
            getPasswordComparison,
            onSelectionRole,
            onSelectionBranch,
            initialize,
        }
    }
);